import styled from '../../../styles/styledComponents/themeComponents';

export const PreviewSimpleProductCardStyle = styled.div`
  margin-bottom: 20px;

  img {
    width: 100%;
  }

  .product-info {
    margin-top: 2px;

    .product-name {
      width: 90%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      letter-spacing: -0.1px;
      font-weight: 500;
    }

    .product-price-info {
      margin-top: 1px;
      font-size: 14px;
      font-weight: bold;
      font-family: Barlow;

      .discount-price {
        margin-right: 2px;
        color: #3e00ff;
      }

      .sales-price {
        color: #000000;

        .unit {
          opacity: 0.8;
          color: #000000;
          font-size: 13px;
          margin-left: 1px;
          letter-spacing: -0.1px;
          font-weight: 500;
        }
      }
    }
  }
`;
